export default "__VITE_ASSET__d89e407c__"